import styles from "../../Global.css"; // Update with your actual stylesheet path

/**
 * AnimateBounce
 * Splits a word into individual animated characters with staggered bounce.
 *
 * @param {string} word - The word to animate.
 * @returns {JSX.Element} React fragment with animated characters.
 */
export const AnimateBounce = (text = "") => {
  return (
    <>
      {[...text].map((char, idx) => (
        <span
          key={idx}
          className="bouncyChar"
          style={{ animationDelay: `${idx * 0.1}s` }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </>
  );
};


